import { B2CPolicy, IEnvironmentVariables } from 'src/environments/IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_SignUp_SignIn',
    signUpSignInRegence: 'B2C_1A_SignUp_SignIn_Regence',
    signUpSignInportalextsso: 'B2C_1A_SignUp_SignIn',
    resetPassword: 'B2C_1A_PasswordReset',
  },
  authorityBaseUrl: 'https://mncportalqa.b2clogin.com/tfp/mncportalqa.onmicrosoft.com',
};

const BASE_URL = 'https://portalqa.mynexuscare.com/';

const API_URL = {
  Platform: 'https://api-platform.portalqa.mynexuscare.com',
  HH: 'https://api-homehealth.portalqa.mynexuscare.com',
  PAC: 'https://api-pacim.portalqa.mynexuscare.com',
  DMEPOS: 'https://api-dmepos.portalqa.mynexuscare.com',
  SDoH: 'https://api-sdoh.portalqa.mynexuscare.com',
  SP: 'https://api-specialtyprograms-gateway.portalqa.mynexuscare.com',
  DocumentGateway: 'https://api-document-gateway.portalqa.mynexuscare.com',
  NotificationGateway: 'https://api-notification-gateway.portalqa.mynexuscare.com',
};

const consentScopes = [
  'https://mncportalqa.onmicrosoft.com/api/api.Write',
  'https://mncportalqa.onmicrosoft.com/api/api.Read',
  'https://mncportalqa.onmicrosoft.com/api/user_impersonation',
];

export const environment: IEnvironmentVariables = {
  production: true,
  b2cPolicies: b2cPolicies,
  baseUrl: BASE_URL,
  appInsightsConnectionString: 'InstrumentationKey=3ecda69c-9384-4916-ad34-aaaaa9f47192;IngestionEndpoint=https://eastus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=1d69692c-4c80-476a-bc2d-10db90fb91df',
  apiUrl: API_URL.HH,
  apiPlatformUrl: API_URL.Platform,
  apiDocumentUrl: API_URL.DocumentGateway,
  apiUrlPacIM: API_URL.PAC,
  apiDMEPOSUrl: API_URL.DMEPOS,
  apiSDoHUrl: API_URL.SDoH,
  apiSpecialtyProgramsUrl: API_URL.SP,
  apiNotificationsUrl: API_URL.NotificationGateway,
  routerUrl: 'https://resourcerouter.portalqa.mynexuscare.com',
  sdohUrl: 'https://sdoh.portalqa.mynexuscare.com/',
  codeManagementUrl: 'https://web-codemanagement.portalqa.mynexuscare.com/',
  extssoBaseUrl: BASE_URL,
  hhProviderFinderUrl : 'https://carelonsolutions--full.sandbox.my.salesforce-sites.com/ProviderFinder',
  authConfig: {
    config: {
      auth: {
        clientId: '386a6be3-ed0d-4bcc-ac0a-178b0d194913',
        postLogoutRedirectUri: BASE_URL,
        redirectUri: BASE_URL,
        knownAuthorities: ['mncportalqa.b2clogin.com'],
      },
      system: {},
    },
    angularConfig: {
      extraQueryParameters: {
        prompt: 'select_account',
      },
      consentScopes: [...consentScopes, 'openid', 'profile'],
      protectedResourceMap: [
        ...Object.values(API_URL).map((url) => [`${url}/*`, consentScopes]),
      ],
    },
  },
  registryUrl: `${API_URL.Platform}/api/app-registry`,
};
